(() => {
  function init(root) {
    if (root.dataset.ptReady) return;
    root.dataset.ptReady = 'true';
    const panels = [...root.querySelectorAll('.pt-detail')];
    const nav = root.querySelector('.pt-tab-nav');
    if (!panels.length || !nav) return;
    const desktop = window.matchMedia('(min-width: 990px)');
    const links = panels.map(panel => {
      const link = document.createElement('a');
      link.href = '#' + panel.id;
      link.textContent = panel.querySelector('summary').textContent;
      nav.append(link);
      return link;
    });
    function activate(panel) {
      links.forEach((link, i) => {
        if (panels[i] === panel) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    }
    function reveal(hash, focus = false) {
      const panel = panels.find(item => '#' + item.id === hash);
      if (!panel) return;
      panel.open = true;
      activate(panel);
      if (focus) {
        panel.querySelector('summary').focus({preventScroll:true});
        panel.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'start'});
      }
    }
    function layout() {
      nav.hidden = !desktop.matches;
      root.classList.toggle('pt-sections-desktop', desktop.matches);
      panels.forEach((panel, i) => {
        panel.hidden = false;
        panel.open = desktop.matches || i === 0 || '#' + panel.id === location.hash;
      });
      reveal(location.hash);
    }
    document.addEventListener('click', event => {
      const link = event.target.closest('a[href^="#pt-"]');
      if (!link || !panels.some(p => '#' + p.id === link.getAttribute('href'))) return;
      event.preventDefault();
      const hash = link.getAttribute('href');
      history.replaceState(null, '', hash);
      reveal(hash, true);
    });
    window.addEventListener('hashchange', () => reveal(location.hash, true));
    desktop.addEventListener('change', layout);
    activate(panels[0]);
    layout();
  }
  function start() {document.querySelectorAll('[data-pt-tabs]').forEach(init);}
  start();
  document.addEventListener('shopify:section:load', start);
})();
